"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionMoveBinding = selectionMoveBinding;
const model_1 = require("../../model");
const draw_state_1 = require("../draw.state");
const label_draw_svg_1 = require("../drawable/label.draw.svg");
const util_draw_svg_1 = require("../drawable/util.draw.svg");
const util_1 = require("../util");
function selectionMoveBinding(dc, evt) {
    const delta = evt.delta;
    if (evt.label === 'image') {
        const centerX = dc.state.centerX;
        const centerY = dc.state.centerY;
        const newPoint = (0, util_1.movePoint)({ x: centerX, y: centerY }, 
        // Moving images is in the opposite direction of the mouse movements
        { x: -delta.x, y: -delta.y }, dc.capture.resolution);
        dc.state.setCenter(newPoint.x, newPoint.y);
        return;
    }
    const currentId = dc.state.selectedId;
    if (currentId == null) {
        return;
    }
    if (evt.$event) {
        evt.$event.preventDefault();
    }
    // If we have the base tool selected, we cannot move any drawables
    if (dc.state.tool === draw_state_1.IkeDrawTool.BASE || dc.state.tool === draw_state_1.IkeDrawTool.LINE) {
        return;
    }
    let drawableToMove = dc.selected;
    if (evt.label === util_draw_svg_1.IkeDrawLabel.LABEL) {
        if (model_1.CollectionModelDrawableMarker.isMarker(drawableToMove) ||
            model_1.CollectionModelDrawableLine.isLine(drawableToMove) ||
            drawableToMove instanceof model_1.CollectionModelDrawableMarkerOffset ||
            drawableToMove instanceof model_1.CollectionModelDrawableVerticalSeparation) {
            return moveLabel(dc, drawableToMove, delta);
        }
    }
    // Dragging a point in the line references the point rather than the line element its self. so we need to target the parent instead
    if (model_1.CollectionModelDrawableLinePoint.isLinePoint(drawableToMove)) {
        drawableToMove = drawableToMove.parent;
    }
    if (drawableToMove.isApprovableInsightDrawable()) {
        drawableToMove.approveInsightFlag();
    }
    if (model_1.CollectionModelDrawableLine.isLine(drawableToMove)) {
        if (evt.label === util_draw_svg_1.IkeDrawLabel.START || evt.label === null) {
            drawableToMove = drawableToMove.start;
        }
        else if (evt.label === util_draw_svg_1.IkeDrawLabel.END) {
            drawableToMove = drawableToMove.end;
        }
    }
    const moveTo = (0, util_1.movePoint)(drawableToMove, delta, dc.capture.resolution);
    if (drawableToMove instanceof model_1.MoveableDrawable) {
        return drawableToMove.move(moveTo.x, moveTo.y);
    }
}
function moveLabel(dc, drawable, delta) {
    const label = drawable.label;
    const uiScale = dc.state.scale;
    const moveTo = (0, util_1.movePoint)(label, delta, dc.capture.resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale,
    });
    label.move(moveTo.x, moveTo.y);
}
//# sourceMappingURL=selection.move.binding.js.map